import api from '../api';

export const independentLeadsService = {
  getAll: async () => {
    const response = await api.get('/independent/leads');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/independent/leads/${id}`);
    return response.data;
  },

  create: async (leadData) => {
    const response = await api.post('/independent/leads', leadData);
    return response.data;
  },

  update: async (id, leadData) => {
    const response = await api.put(`/independent/leads/${id}`, leadData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/independent/leads/${id}`);
    return response.data;
  },

  convertToClient: async (leadId) => {
    const response = await api.post(`/independent/leads/${leadId}/convert`);
    return response.data;
  }
};

export default independentLeadsService;
